module.exports = __webpack_public_path__ + "static/hero-main-img.2b7848ec.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/hero-main-img.svg
// module id = 1290
// module chunks = 35783957827783